import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {ReceiptInfoResultVo} from '../../common/shared/api/nicolas/vo/billing/ReceiptInfoResultVo.interface';

/**
 * 현금영수증 발행정보 조회
 *
 * Origin: pageNicolasApi.getReceiptInfoResult
 * API: POST /api/v1/store/receipt
 */
export async function postStoreReceipt(
  {
    creditMasterId,
  }: {
    creditMasterId: string;
  },
  options?: FetcherOptions
): Promise<ApiResultVo & {data: ReceiptInfoResultVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/store/receipt',
    {
      method: 'POST',
      data: {
        credit_master_id: creditMasterId,
      },
    },
    options
  );
  return response.data;
}
